import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { fromLonLat } from "ol/proj";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Fill from "ol/style/Fill";


import KML from "ol/format/KML";


  import { 
    katasterLayerGroup,
    amapLayer,
    orthoLayer,
    gt380Layer,
    gt220Layer,
    gt110Layer,
    demontageLayerGroup,
    pt380Layer,
    pt220Layer,
    pt110Layer,
    hinweiseLayer,
    uwLayer,
    anschlusspunkteLayer,
    mastStandorteLayer,
    demontageMastGroup,
    wegeplanungLayer,
  } from "./layers.js";


const kmlLayer = new VectorLayer({
  source: new VectorSource({
    url: "/data/flseil.kml",
    format: new KML({
      extractStyles: true,   // liest Styles aus KML
    }),
  }),
  // optional überschreiben wir die Styles:
  style: new Style({
    stroke: new Stroke({
      color: "purple",
      width: 2,
    }),
    fill: new Fill({
      color: "rgba(128, 0, 128, 0.2)",
    }),
  }),
});


const map = new Map({
  target: "map",
  layers: [
    amapLayer,
    orthoLayer,
    katasterLayerGroup,
    
    uwLayer,
    // gt380Layer,
    // gt220Layer,
    // gt110Layer,
    
    // wegeplanungLayer,
    demontageLayerGroup,
    // demontageMastGroup,
    // hinweiseLayer,
    
    pt380Layer,
    pt220Layer,
    pt110Layer,
    // mastStandorteLayer,
    


    // anschlusspunkteLayer,


  ],
  view: new View({
    center: fromLonLat([13.6, 46.8]),
    zoom: 8.9,
  }),
});


document.querySelectorAll('#legend div').forEach(cb => {
  cb.addEventListener("click", (event) => {
    const layerId = event.target.dataset.layer;
    map.getLayers().forEach(layer => {
      if (layer.get("layerId") === layerId) {
        const visible = layer.getVisible();
        layer.setVisible(!visible);
        console.log(layer);
        if (visible) {
          event.target.parentNode.style.opacity = 0.3;
        } else {
          event.target.parentNode.style.opacity = 1;
        }
      }
    });
  });
});

